import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";
import type { BannerVariantsType } from "./Banner";

// STYLES
const warrantySaleType = css`
    --header-spacing-block: calc(var(--spacing-3) / 2);
    --header-spacing-inline: var(--spacing-2);
    --header-border-width: 1px;
    --header-border-color: var(--color-grey-6);
    --header-background: var(--color-grey-1);
    --body-spacing-block: var(--spacing-3);
    --body-spacing-inline: var(--spacing-3);
    --border-radius: 4px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: var(--color-primary-white);
    border: 1px solid var(--color-grey-6);
    border-radius: 4px;
`;

const warranty = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: var(--spacing-3);
    background-color: var(--color-primary-white);

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        align-self: stretch;
        column-gap: var(--spacing-4);
        row-gap: 0;
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        padding: var(--spacing-3);
    }

    @supports not (padding-inline: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-right: var(--spacing-4);
        }
    }
`;

const customerSupport = css`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-3);
    margin-inline: calc(var(--spacing-2) * -1);
    padding: var(--spacing-3);
    background-color: var(--color-grey-4);

    @media (min-width: ${breakpoints.md}) {
        margin-inline: calc(var(--spacing-3) * -1);
    }

    @media (min-width: ${breakpoints.lg}) {
        margin-inline: 0;
    }

    @supports not (row-gap: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-3) !important;
        }
    }
`;

// COMPONENTS
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-2);

    @media screen and (min-width: ${breakpoints.lg}) {
        row-gap: var(--spacing-3);
    }

    @supports not (padding-inline: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-2);
        }

        @media screen and (min-width: ${breakpoints.lg}) {
            & > *:not(:nth-last-child(1)) {
                margin-bottom: var(--spacing-3);
            }
        }
    }
`;

export const Header = styled.div`
    --_header-spacing-block: var(--header-spacing-block, calc(var(--spacing-3) / 2));
    --_header-spacing-inline: var(--header-spacing-inline, var(--spacing-2));
    --_header-background: var(--header-background, transparent);
    --_header-border-width: var(--header-border-width, 0);
    --_header-border-color: var(--header-border-color, transparent);
    --_border-radius: var(--border-radius, 0);

    display: flex;
    align-items: center;
    gap: var(--spacing-1);
    width: 100%;
    padding-block: var(--_header-spacing-block);
    padding-inline: var(--_header-spacing-inline);
    background: var(--_header-background);
    border-bottom: var(--_header-border-width) solid var(--_header-border-color);
    border-top-left-radius: var(--_border-radius);
    border-top-right-radius: var(--_border-radius);

    @supports not (padding-block: 0) {
        padding-top: var(--_header-spacing-block);
        padding-bottom: var(--_header-spacing-block);
        padding-left: var(--_header-spacing-inline);
        padding-right: var(--_header-spacing-inline);

        svg,
        .dxp-icon {
            margin-right: var(--spacing-1);

            [dir="rtl"] & {
                margin-left: var(--spacing-1);
                margin-right: unset;
            }
        }
    }
`;

export const Body = styled.div`
    --_body-spacing-block: var(--body-spacing-block, var(--spacing-3));
    --_body-spacing-inline: var(--body-spacing-inline, var(--spacing-3));

    width: 100%;
    padding-block: var(--_body-spacing-block);
    padding-inline: var(--_body-spacing-inline);

    @supports not (padding-block: 0) {
        padding-top: var(--_body-spacing-block);
        padding-bottom: var(--_body-spacing-block);
        padding-left: var(--_body-spacing-inline);
        padding-right: var(--_body-spacing-inline);
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-3);
    padding: var(--spacing-3);
    background-color: var(--color-primary-white);

    & > div {
        width: 100%;
        &:nth-child(1) {
            display: flex;
            flex-direction: column;
            row-gap: calc(var(--spacing-3) / 2);
        }
    }

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        column-gap: var(--spacing-3);
        row-gap: 0;
        & > div {
            width: 50%;
        }
    }

    @supports not (padding-inline: 0) {
        & > div {
            &:not(:nth-last-child(1)) {
                margin-right: var(--spacing-3);
            }
            &:nth-child(1) {
                & > *:not(:nth-last-child(1)) {
                    margin-bottom: calc(var(--spacing-3) / 2) !important;
                }
            }
        }
    }
`;

export const BannerVariants = {
    warranty,
    "warranty-sale-type": warrantySaleType,
    "customer-support": customerSupport,
};

const BannerVariant = styled.div<{ variant: BannerVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${BannerVariants[variant]};
        `};
`;

export default BannerVariant;
